"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeContainer = void 0;
const react_1 = require("react");
const useResizeContainer = (refElement) => {
    const [width, setWidth] = (0, react_1.useState)(0);
    const [height, setHeight] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        const currentRefElement = refElement.current;
        // set initial value only if we have 0 value
        if (currentRefElement && !width) {
            setWidth(() => currentRefElement.offsetWidth);
            setHeight(() => currentRefElement.offsetHeight);
        }
        const getWidth = () => {
            if (currentRefElement) {
                setWidth(() => currentRefElement.offsetWidth);
                setHeight(() => currentRefElement.offsetHeight);
            }
        };
        window.addEventListener('resize', getWidth);
        return () => window.removeEventListener('resize', getWidth);
    }, [refElement, width]);
    return [width, height];
};
exports.useResizeContainer = useResizeContainer;
//# sourceMappingURL=useResizeContainer.js.map